import { Outlet } from 'react-router-dom';
import { AnalyticsProvider } from './common/AnalyticsProvider';

/**
 * Root layout component that wraps all routes
 * 
 * Responsibilities:
 * - Initialize and manage analytics tracking
 * - Can be extended for other global concerns (error boundaries, etc.)
 */
export function RootLayout() {
  return (
    <>
      <AnalyticsProvider />
      <Outlet />
    </>
  );
}
